export enum StatusCode {
    Conflict = 409,
}
